
import Vue from "vue";

export default Vue.extend({
  props: {
    activeMenu: Number,
    isOpen: Boolean,
    MaxSizeClass: String,
    justifyModalClass: String,
  },
  data() {
    return {
      canClose: false,
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // Permitir cerrar el modal solo después de un pequeño delay
        this.canClose = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.canClose = true;
          }, 100);
        });
      }
    },
  },
  methods: {
    modalClose() {
      if (this.canClose) {
        this.$emit("closeModal", true);
      }
    },
  },
});
